import { Component, OnInit } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { UtilsService } from 'src/app/services/utils.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import { ExportService } from 'src/app/services/export.service';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { BULK_UPLOAD, COMMON_CONSTANTS, VALUE, EXCEL_JS, SUSPEND_CONSTANTS,
  TRANSFER_NUMBER_CONSTANTS, MANAGE_LINE_CONST, ANALYTICS, CANCEL_SUBSCRIBER_REASONS, SIM_CHANGE_CONST } from 'src/app/common/core/common.constants';
import { ContentService } from 'src/app/services/content.service';
import { PDLService } from 'src/app/services/pdl-service.service';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { TransactionHistoryService } from 'src/app/services/transaction-histroy.service';


@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class SuccessComponent implements OnInit {

  token: any;
  header: any;
  authoringContentData: any;
  orderStatus: any;
  modalBodyContent: string;
  bulkOrderStatus: any;
  bulkRestoreData: any;
  bulkChangeNumberData: any;
  bulkSuspendData: any;
  bulkSimSwapData: any;
  bulkCancelSubscriberData: any;
  bulkChangeServiceData: any;
  bulkManagePairingData: any;
  bulkStrategicPortInData: any;
  transactionID;
  logonEmailId: string;

  bulkUploadFlow: boolean;
  flowType: string;
  portInSuccessTransaction: string;
  portInOrderID: any;
  isPortIn: boolean;
  isChangeNumber: any;
  newSimNumber: any;
  isSimChange: any;
  isCancelSubscriber: boolean;
  isChangeService: boolean;
  processText: any;
  isLineDetailsWindow: boolean;
  isConfirmationPopup: boolean;
  isRestore: boolean;
  isSuspend: boolean;
  isBillingAddressUpdated: boolean;
  multiLineFlow: boolean;
  selectedLines: any;
  eidLength: number = 0;
  tagEnabledByCaller: boolean;
  nameTag: string;
  eSimEnabled = environment.ENABLE_ESIM;
  strategicPortIn:boolean = false;
  templateObj: any[];
  worksheetname: any;
  response:any;
  transactionLines:any;
  filteredArray: any[];
  portInSuccessBody: string;
  lhFlag:boolean;


  constructor(public manageLineService: ManageLineService, public utilsSvc: UtilsService,
    private exportSvc: ExportService, private _cacheSvc: HttpCacheService, public contentService: ContentService,
    private pdlService: PDLService, private transactionSvc: TransactionHistoryService) { }

  ngOnInit() {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
    this._cacheSvc.putInSessionStoarage(MANAGE_LINE_CONST.PREVIOUS_SELECTED_LINES, '[]');
    this._cacheSvc.putInSessionStoarage('isTransaction', 'true');
    this.flowType = ContentService.GetCache(BULK_UPLOAD.BULK_FLOW_KEY);
    this.logonEmailId = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)).logonId;
    this.eidLength = SIM_CHANGE_CONST.E_SIM_NUM_LENGTH;
    this.portInSuccessBody = this.authoringContentData.manageLine.portInSuccess.replace(
          "{{emailID}}",
          _.get(
            JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)) || {},
            "logonId",
            ""
          )
        );    
    this.generateModalViewTag({
      eventAction: ANALYTICS.LOAD,
      modalName: this.header,
      stage: ANALYTICS.COMPLETE,
      name: this.nameTag
    });
  }

  finishTransaction() {
    this.manageLineService.close();
    this.manageLineService.completeTransaction(true);
  }

  downloadSpreadsheet() {
    switch (this.flowType) {
      case BULK_UPLOAD.CHANGE_PHONE_KEY:
        this.downloadChangeNumberData();
        break;
      case BULK_UPLOAD.SIM_SWAP_KEY:
        this.downloadSimSwapData();
        break;
      case BULK_UPLOAD.SUSPEND_KEY:
        this.downloadSuspendData();
        break;
      case BULK_UPLOAD.RESTORE_KEY:
        this.downloadRestoreData();
        break;
      case BULK_UPLOAD.TRANSFER_NUMBERS:
        this.generateClickEventTag({
          type: ANALYTICS.CLICK_TO_NAVIGATE,
          action: ANALYTICS.CLICK,
          ctaName: this.authoringContentData?.manageLine?.downloadSuccessItems,
          assetType: ANALYTICS.LINK,
          modalName: this.authoringContentData.transferNumberAuthoring.bulkLineSuccessModalTitle
        });
        this.downloadTransferNumberData();
        break;
      case BULK_UPLOAD.CHANGE_SERVICE:
        this.downloadChangeServiceData();
        break;
      case BULK_UPLOAD.CANCEL_SUBSCRIBER:
        this.downloadCancelSubscriberData();
        break;
      case BULK_UPLOAD.MANAGE_PAIRING:
        this.downloadManagePairingData();
        break;
      case BULK_UPLOAD.STRATEGIC_PORT_IN:
        this.downloadStrategicPortInData();
        break;
    }
  }

  downloadCancelSubscriberData() {
    if (!isNullOrUndefined(this.bulkCancelSubscriberData)) {
      const tmp = [];
      let obj = {};
      let dateChange;
      const codeToReason = this.makeCancelSubscriberCodeReasonMap();
      for(const req of this.bulkCancelSubscriberData) {
        obj = {};
        dateChange = req.activityDate.split("-");

        obj[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT] = req.mobileNumber;
        obj[BULK_UPLOAD.CANCEL_DATE] = dateChange[1] + "/" + dateChange[2] + "/" + dateChange[0];
        obj[BULK_UPLOAD.CANCEL_REASON] = codeToReason[req.reasonCode];
        tmp.push(obj)
      }
      this.exportSvc.exportAsExcelFile(tmp, BULK_UPLOAD.BULK_TEMPLATE_CHANGE_SERVICE);
    }
  }

  downloadChangeServiceData() {
    if (!isNullOrUndefined(this.bulkChangeServiceData)) {
      const columns = Object.keys(this.bulkChangeServiceData[0]);
      const requests = [];
      let obj;
      for(const req of this.bulkChangeServiceData) {
        obj = {};
        for (const column of columns) {
          obj[column] = req[column]
        }
        requests.push(obj)
      }
      this.exportSvc.exportAsExcelFile(requests, BULK_UPLOAD.BULK_TEMPLATE_CHANGE_SERVICE);
    }
  }

  downloadTransferNumberData() {
    let temp1;
    const transferNumberData = ContentService.GetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY);
    const validData = Object.assign([], transferNumberData[0]);
    if (!isNullOrUndefined(transferNumberData)) {
      const transferNumberTemplate = [];
      for(let line of validData) {
        if (line) {
          temp1 = this.getTransferNumberBulkLineData(line);
          transferNumberTemplate.push(temp1);
        }
      }
      const fileName = this.transactionID + COMMON_CONSTANTS.UNDERSCORE + BULK_UPLOAD.BULK_PORTIN_SUCCESS_DOWNLOAD;
      this.exportSvc.exportAsExcelFile(transferNumberTemplate, fileName);
    }
  }

  getTransferNumberBulkLineData(line) {
    const temp1 = {};
    // tslint:disable-next-line: max-line-length
    temp1[BULK_UPLOAD.MSISDN_NUMBER_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.MSISDN_NUMBER_TXT]) ? line[BULK_UPLOAD.MSISDN_NUMBER_TXT] : '';
    // tslint:disable-next-line: max-line-length
    temp1[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT]) ? line[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT] : '';
    // tslint:disable-next-line: max-line-length
    temp1[BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER] = !isNullOrUndefined(line[BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER]) ? line[BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER] : '';
    // tslint:disable-next-line: max-line-length
    temp1[BULK_UPLOAD.ACCOUNT_PIN_OR_PASSWORD] = !isNullOrUndefined(line[BULK_UPLOAD.ACCOUNT_PIN_OR_PASSWORD]) ? line[BULK_UPLOAD.ACCOUNT_PIN_OR_PASSWORD] : '';
    temp1[BULK_UPLOAD.PORT_DATE_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.PORT_DATE_TXT]) ? this.formatMonth(this.formatYear(line[BULK_UPLOAD.PORT_DATE_TXT])) : '';
    temp1[BULK_UPLOAD.PORT_START_TIME_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.PORT_START_TIME_TXT]) ? line[BULK_UPLOAD.PORT_START_TIME_TXT] : '';

    temp1[BULK_UPLOAD.RESULT_TXT] = MANAGE_LINE_CONST.SUCCESSFULLY_SUBMITTED;
    return temp1;
  }

  formatYear(date: string) {
    const arraySplit = date.split(COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH);
    if (!isNullOrUndefined(arraySplit[2]) && ((arraySplit[2]).toString()).length === 2) {
      arraySplit[2] = VALUE.TWENTY + arraySplit[2];
      return arraySplit.join(COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH);
    } else {
      return date;
    }
  }

  formatMonth(date: string) {
    const arraySplit = date.split(COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH);
    if (((arraySplit[0]).toString()).length === COMMON_CONSTANTS.DIGITS.TWO && (arraySplit[0]).toString().indexOf('0') === COMMON_CONSTANTS.DIGITS.ZERO) {
      const month = arraySplit[0].toString().substring(COMMON_CONSTANTS.DIGITS.ONE, COMMON_CONSTANTS.DIGITS.TWO);
      arraySplit[0] = month;
      return arraySplit.join(COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH);
    } else {
      return date;
    }
  }

  downloadSimSwapData() {
    let temp;
    let excelName;
    if (!isNullOrUndefined(this.bulkSimSwapData && this.bulkSimSwapData.requests)) {
      const simSwapTemplate = [];
      for(let line of this.bulkSimSwapData.requests) {
        if (line) {
          temp = this.getSimSwapLineData(line);
          simSwapTemplate.push(temp);
        }
      }
      excelName = this.eSimEnabled ? BULK_UPLOAD.ESIM_SWAP_SUCCESS_DOWNLOAD : BULK_UPLOAD.SIM_SWAP_SUCCESS_DOWNLOAD;
      this.exportSvc.exportAsExcelFile(simSwapTemplate, excelName);
    }
  }

  getSimSwapLineData(line) {
    const temp = {};
    temp['PhoneNumber'] = !isNullOrUndefined(line.msisdn) && line.msisdn !== '' ? Number(line.msisdn) : '';
    temp['OldSim'] = !isNullOrUndefined(line.OldSim) && line.OldSim !== '' ? line.OldSim : '';
    this.assignEIDNewSimColumn(temp,line);
    temp['Reason_For_Change'] = !isNullOrUndefined(line.reasonCode) && line.reasonCode !== '' ? this.getSimSwapReason(line.reasonCode) : '';
    temp[BULK_UPLOAD.RESULT_TXT] = !isNullOrUndefined(this.authoringContentData && this.authoringContentData.manageLineRestore
      && this.authoringContentData.manageLineRestore.restoreMsginDownloadTxt) ?
      this.authoringContentData.manageLineRestore.restoreMsginDownloadTxt : '';
    this.assignNoteColumn(temp);
    return temp;
  }
  assignEIDNewSimColumn(temp,line){
    if(this.eSimEnabled){
      temp['EID (for eSIM)'] = !isNullOrUndefined(line.eid) && (line.eid).length === SIM_CHANGE_CONST.E_SIM_NUM_LENGTH ? line.eid : '';
      temp['NewSIM (for Physical SIM)'] = !isNullOrUndefined(line.newSim) && (line.newSim).length !== SIM_CHANGE_CONST.E_SIM_NUM_LENGTH ? line.newSim : '';
    }else{
      temp['NewSim'] = !isNullOrUndefined(line.newSim) && (line.newSim).length !== SIM_CHANGE_CONST.E_SIM_NUM_LENGTH ? line.newSim : '';
    }
  }
  assignNoteColumn(temp){
    if(this.eSimEnabled){
      temp[EXCEL_JS.NOTE_ESIM_SWAP] = '';
    }else{
      temp[EXCEL_JS.NOTE_SIM_SWAP] = '';
    }
  }

  getSimSwapReason(reasonCode: string) {
    if (!isNullOrUndefined(reasonCode) && reasonCode !== '') {
      switch (reasonCode) {
        case BULK_UPLOAD.SIM_CHANGE_REASON_BYOS: return BULK_UPLOAD.CUSTOMER_SIM_SIM_IN_KIT;
        case BULK_UPLOAD.SIM_CHANGE_REASON_CR: return BULK_UPLOAD.CUSTOMER_EMPLOYEE_REQUEST;
        case BULK_UPLOAD.SIM_CHANGE_REASON_DFS: return BULK_UPLOAD.VALIDATED_DEFECTIVE_SIM;
        case BULK_UPLOAD.SIM_CHANGE_REASON_LS: return BULK_UPLOAD.LOST_STOLEN_DAMAGED_SIM;
      }
    } else {
      return '';
    }
  }

  downloadSuspendData() {
    let temp = {};
    if (!isNullOrUndefined(this.bulkSuspendData)) {
      const suspendTemplate = [];
      for(let line of this.bulkSuspendData) {
        if (line) {
          temp = this.getSuspendLineData(line);
          suspendTemplate.push(temp);
        }
      }
      this.exportSvc.exportAsExcelFile(suspendTemplate, BULK_UPLOAD.SUSPEND_SUCCESS_DOWNLOAD);
    }
  }

  getSuspendLineData(line) {
    const temp = {};
    temp[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT] = !isNullOrUndefined(line.msisdn) ? Number(line.msisdn) : '';
    temp[BULK_UPLOAD.BULK_SUSPEND_REASON_TXT] = !isNullOrUndefined(line.reasonCode) ? this.getSuspendReasonCode(line.reasonCode) : '';
    temp[BULK_UPLOAD.BULK_SUSPEND_APPROVER_TXT] = !isNullOrUndefined(line.validatorType) && line.reasonCode !== 'ELST'  ? line.validatorType : '';
    temp[BULK_UPLOAD.BULK_SUSPEND_STARTDATE_TXT] = !isNullOrUndefined(line.suspendStartDate) && line.reasonCode !== 'ELST' ? this.transformDate(line.suspendStartDate) : '';
    temp[BULK_UPLOAD.BULK_SUSPEND_ENDDATE_TXT] = !isNullOrUndefined(line.restoreDate) && line.reasonCode !== 'ELST' ? this.transformDate(line.restoreDate) : '';
    temp[BULK_UPLOAD.RESULT_TXT] = !isNullOrUndefined(this.authoringContentData && this.authoringContentData.manageLineRestore
      && this.authoringContentData.manageLineRestore.restoreMsginDownloadTxt) ?
      this.authoringContentData.manageLineRestore.restoreMsginDownloadTxt : '';
    return temp;
  }

  getSuspendReasonCode(reasonCode) {
    switch (reasonCode) {
      case SUSPEND_CONSTANTS.TEMP_SUSPEND:
        return SUSPEND_CONSTANTS.TEMP_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES:
        return SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES_TXT;
      case SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES:
        return SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES_TXT;
      case SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND:
        return SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.SEASONAL_SUSPEND:
        return SUSPEND_CONSTANTS.SEASONAL_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.MILTARY_SUSPEND:
        return SUSPEND_CONSTANTS.MILTARY_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.EDUCATION_SUMMER_SUSPEND:
        return SUSPEND_CONSTANTS.EDUCATION_SUMMER_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.IMPLEMENTATION_SUSPEND:
        return SUSPEND_CONSTANTS.IMPLEMENTATION_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.MCSA_CONTRACTUAL_SUSPEND:
        return SUSPEND_CONSTANTS.MCSA_CONTRACTUAL_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.SUNC_SUSPEND:
        return SUSPEND_CONSTANTS.SUNC_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.RETENTION_SUSPEND:
        return SUSPEND_CONSTANTS.RETENTION_SUSPEND_TXT;
    }
  }

  transformDate(date: string) {
    if (!isNullOrUndefined(date)) {
      const splitDate = date.split(COMMON_CONSTANTS.SYMBOLS.DASH);
      // tslint:disable-next-line: max-line-length
      return splitDate.length === VALUE.THREE ? splitDate[VALUE.ONE] + COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH + splitDate[VALUE.TWO] + COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH + splitDate[VALUE.ZERO] : date;
    } else {
      return '';
    }
  }

  downloadRestoreData() {
    let temp1;
    const restoreLine = ContentService.GetCache(BULK_UPLOAD.RESTORE_SUCCESS_DATA);
    if (!isNullOrUndefined(restoreLine) && restoreLine.length > VALUE.ZERO) {
      restoreLine.filter((line: any) => {
        if (line[BULK_UPLOAD.BULK_UPLOAD_RESTORE_DATE].includes(COMMON_CONSTANTS.SYMBOLS.DASH)) {
          const splitDate = line[BULK_UPLOAD.BULK_UPLOAD_RESTORE_DATE].split(COMMON_CONSTANTS.SYMBOLS.DASH);
          const formatedDate = splitDate.length === VALUE.THREE ? splitDate[VALUE.ONE] + COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH + splitDate[VALUE.TWO] +
            COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH + splitDate[VALUE.ZERO] : '';
          line[BULK_UPLOAD.BULK_UPLOAD_RESTORE_DATE] = formatedDate;
        }
      });
    }
    if (!isNullOrUndefined(restoreLine)) {
      const changePhoneTemplate = [];
      for(let line of restoreLine) {
        temp1 = this.getRestoreLineData(line);
        changePhoneTemplate.push(temp1);
      }
      this.exportSvc.exportAsExcelFile(changePhoneTemplate, BULK_UPLOAD.RESTORE_SUCCESS_DOWNLOAD);
    }
  }

  getRestoreLineData(line) {
    const temp1 = {};
    temp1['PhoneNumber'] = !isNullOrUndefined(line[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT] && line[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT] !== '') ?
    Number(line[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT]) : '';
    temp1['RestoreDate'] = !isNullOrUndefined(line[BULK_UPLOAD.BULK_UPLOAD_RESTORE_DATE] && line[BULK_UPLOAD.BULK_UPLOAD_RESTORE_DATE] !== '') ?
    line[BULK_UPLOAD.BULK_UPLOAD_RESTORE_DATE] : '';
    temp1['Result'] = !isNullOrUndefined(this.authoringContentData && this.authoringContentData.manageLineRestore && this.authoringContentData.manageLineRestore.restoreMsginDownloadTxt) ?
      this.authoringContentData.manageLineRestore.restoreMsginDownloadTxt : '';
    return temp1;
  }

  downloadChangeNumberData() {
    let temp1;
    if (!isNullOrUndefined(this.bulkChangeNumberData)) {

      const changePhoneTemplate = [];
      for(let line of this.bulkChangeNumberData) {
        if (line) {
          temp1 = this.getChangeNumberData(line);
          changePhoneTemplate.push(temp1);
        }
      }
      this.exportSvc.exportAsExcelFile(changePhoneTemplate, BULK_UPLOAD.CHANGE_NUMBER_SUCCESS_DOWNLOAD);
    }
  }

  getChangeNumberData(line) {
    const temp1 = {};
    temp1['PhoneNumber'] = !isNullOrUndefined(line.PhoneNumber) ? Number(line.PhoneNumber) : '';
    temp1['Preferred_Area_Code'] = !isNullOrUndefined(line.Preferred_Area_Code) ? line.Preferred_Area_Code : '';
    temp1['Reason_For_Change'] = !isNullOrUndefined(line.Reason_For_Change) ? line.Reason_For_Change : '';
    temp1['Result'] = !isNullOrUndefined(this.authoringContentData && this.authoringContentData.changeNumberAuthoring
      && this.authoringContentData.changeNumberAuthoring.changeNumberDownloadResultText) ?
      this.authoringContentData.changeNumberAuthoring.changeNumberDownloadResultText : '';
    return temp1;
  }

  closeSuccessPopup() {
    if (this.isBillingAddressUpdated === true) {
      this.manageLineService.close();
      this.manageLineService.billingAddressUpdated.next(true);
    } else if(this.strategicPortIn){
      this.manageLineService.close();
      this.transactionSvc.fromStrategicPortIn.next(true);
    }else if (this.lhFlag){
      this.manageLineService.close()
      this.manageLineService.callFetchNotification.next(true);
    }
    else {
      this.manageLineService.closeSuccessPopup(this.isLineDetailsWindow);
    }
    this.generateClickEventTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.CLOSE,
      assetType: ANALYTICS.LINK,
      modalName: this.header,
    });
  }
  downloadTransferNumberMultiLineData() {
    this.generateClickEventTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: this.authoringContentData?.manageLine?.downloadSuccessItems,
      assetType: ANALYTICS.LINK,
      modalName: this.authoringContentData.transferNumberAuthoring.MultiLineSuccessModalTitle
    });

    let temp1;
    const transferNumberData = this.selectedLines;
    const validData = Object.assign([], transferNumberData);
    if (!isNullOrUndefined(transferNumberData)) {
      const transferNumberTemplate = [];
      for(let line of validData) {
        if (line) {
          temp1 = this.getTransferNumberLineData(line);
          transferNumberTemplate.push(temp1);
        }
      }
      const fileName = this.transactionID + COMMON_CONSTANTS.UNDERSCORE + BULK_UPLOAD.BULK_PORTIN_SUCCESS_DOWNLOAD;
      ContentService.SetCache(BULK_UPLOAD.BULK_FLOW_KEY,BULK_UPLOAD.TRANSFER_NUMBERS);
      this.exportSvc.exportAsExcelFile(transferNumberTemplate, fileName);
    }
  }

  getTransferNumberLineData(line) {
    const temp1 = {};
    // tslint:disable-next-line: max-line-length
    temp1[BULK_UPLOAD.MSISDN_NUMBER_TXT] = !isNullOrUndefined(line[TRANSFER_NUMBER_CONSTANTS.MSISDN]) ? line[TRANSFER_NUMBER_CONSTANTS.MSISDN] : '';
    // tslint:disable-next-line: max-line-length
    temp1[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT] = !isNullOrUndefined(line[TRANSFER_NUMBER_CONSTANTS.TRAN_NUMBER]) ? line[TRANSFER_NUMBER_CONSTANTS.TRAN_NUMBER] : '';
    // tslint:disable-next-line: max-line-length
    temp1[BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER] = !isNullOrUndefined(line[TRANSFER_NUMBER_CONSTANTS.CARRIER_NUMBER]) ? line[TRANSFER_NUMBER_CONSTANTS.CARRIER_NUMBER] : '';
    // tslint:disable-next-line: max-line-length
    temp1[BULK_UPLOAD.ACCOUNT_PIN_OR_PASSWORD] = !isNullOrUndefined(line[TRANSFER_NUMBER_CONSTANTS.ACCOUNT_PIN_PASS]) ? line[TRANSFER_NUMBER_CONSTANTS.ACCOUNT_PIN_PASS] : '';
    let formateedDate = line[TRANSFER_NUMBER_CONSTANTS.PORT_DATE].month + '/' + line[TRANSFER_NUMBER_CONSTANTS.PORT_DATE].day + '/' + line[TRANSFER_NUMBER_CONSTANTS.PORT_DATE].year;
    temp1[BULK_UPLOAD.PORT_DATE_TXT] = !isNullOrUndefined(formateedDate) ? this.formatMonth(this.formatYear(formateedDate)) : '';
    temp1[BULK_UPLOAD.RESULT_TXT] = MANAGE_LINE_CONST.SUCCESSFULLY_SUBMITTED;
    return temp1;
  }

  generateClickEventTag(clickEventInfo) {
    if (this.tagEnabledByCaller) {
      this.pdlService.ifEnabledGenerateClickTag(clickEventInfo);
    }
  }

  generateModalViewTag(modalInfo) {
    if (this.tagEnabledByCaller) {
      this.pdlService.ifEnabledGenerateModalViewTag(modalInfo);
    }
  }

  makeCancelSubscriberCodeReasonMap() {
    const map = {};
    for(const reason of CANCEL_SUBSCRIBER_REASONS) {
      map[reason.code] = reason.description;
    }
    return map;
  }

  downloadManagePairingData() {
    if (!isNullOrUndefined(this.bulkManagePairingData)) {
      const requests = [];
      let obj;

      for(const req of this.bulkManagePairingData) {
        obj = {};
        obj[BULK_UPLOAD.MNG_PAIRING_MOBILE_LINE] = req['gsmLine'];
        obj[BULK_UPLOAD.MNG_PAIRING_DIGITS_LINE] = req['digitsLine'];
        obj[BULK_UPLOAD.MNG_PAIRING_ACTION] = req['action'];

        requests.push(obj)
      }
      this.exportSvc.exportAsExcelFile(requests, BULK_UPLOAD.BULK_TEMPLATE_MANAGE_PAIRING);
    }
  }

  downloadStrategicPortInData() {
    if (!isNullOrUndefined(this.bulkStrategicPortInData)) {
      let obj;
      const requests = [];
      for(const req of this.bulkStrategicPortInData) {
        obj = {};
        obj[BULK_UPLOAD.STRATEGIC_PORT_IN_TMO_MSISDN] = req['msisdn'];
        obj[BULK_UPLOAD.STRATEGIC_PORT_IN_TEMP_MSISDN] = req['newMsisdn'];
        obj[BULK_UPLOAD.STRATEGIC_PORT_IN_CARRIER_ACC_NUM] = req['ospAccount'];
        obj[BULK_UPLOAD.STRATEGIC_PORT_IN_ACC_PIN] = req['ospAccountPassword'];

        requests.push(obj)
      }
      this.exportSvc.exportAsExcelFile(requests, BULK_UPLOAD.BULK_TEMPLATE_STRATEGIC_PORT_IN);
    }
  }
}
